import React, { useState } from "react";
import { Formik } from "formik";
import { useParams } from "react-router-dom";

import { postMethod } from "../../utils/axios";
import FormikError from "../../components/home/formikError/formikError";
import CheckBoxCourse from "../../components/home/checkBoxCourse";
import { isMobile } from "react-device-detect";
import CheckBox from "../../components/home/checkBox";
import Inputs from "../../components/home/input";
import FallPage from "../fallPage";
import SuccessPage from "../successPage";
import Loader from "../../components/home/loader";
import { courseType } from "../../components/home/checkBoxCourse/data";
import { validatePhone } from "../../helpers/phone";
import "./homePage.css";

export default function HomePage() {
  const [page, setPage] = useState("normal");
  const [activeLoader, setActiveLoader] = useState(false);
  const { type } = useParams();

  const typeId = type || 1;

  const renderSwitch = (param) => {
    switch (param) {
      case "normal":
        return (
          <div>
            <header className={isMobile ? "header-text-mobile" : "header-text"}>
            {Number(type) === 5 ||
              Number(type) === 6 ||
              Number(type) === 7 ? (
                <div>
                  {" "}
                  <div>נפתח עבורך חלון</div>
                  <div>הזדמנויות נוסף בגפ"ן</div>
                </div>
              ) : (
                <div>
                  <div>מטח של הזדמנויות</div>
                  <div>במאגר התוכניות של גפ"ן</div>
                </div>
              )}
            </header>
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                mobileNumber: "",
                email: "",
                schoolName: "",
                symbol: "",
                role: "",
                city: "",
                courses: [],
                newLetter: false,
              }}
              isValid={(value) => {
                console.log(value);
              }}
              validate={(values) => {
                const errors = {};
                if (!values.firstName) {
                  errors.firstName = "שדה חובה";
                }

                if (!values.lastName) {
                  errors.lastName = "שדה חובה";
                }

                if (!values.mobileNumber) {
                  errors.mobileNumber = "שדה חובה";
                } else if (!validatePhone(values.mobileNumber)) {
                  errors.mobileNumber = "מספר נייד לא תקין";
                }

                if (!values.email) {
                  errors.email = "שדה חובה";
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = "כתובת מייל לא תקינה";
                }

                if (!values.schoolName) {
                  errors.schoolName = "שדה חובה";
                }

                if (!values.symbol) {
                  errors.symbol = "שדה חובה";
                }

                if (!values.city) {
                  errors.city = "שדה חובה";
                }

                if (!values.role) {
                  errors.role = "שדה חובה";
                }

                if (!values.courses.length) {
                  errors.courses = "שדה חובה";
                }
                return errors;
              }}
              onSubmit={async (values) => {
                try {
                  const object = {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    phone: values.mobileNumber,
                    email: values.email,
                    school: values.schoolName,
                    position: values.role,
                    symbol: values.symbol,
                    city: values.city,
                    programs: values.courses,
                    newsletter: values.newLetter,
                    type: typeId?.toString() || 0,
                  };

                  setActiveLoader(true);
                  await postMethod("submit", object)
                    .then((n) => {
                      setPage("ok");
                    })
                    .catch((e) => {
                      console.error(e);
                      setPage("bad");
                      setActiveLoader(false);
                    });
                  window.scrollTo(0, 0);

                  setActiveLoader(false);
                } catch {
                  setPage("bad");
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className={isMobile ? "" : "flex"}>
                    <Inputs
                      title={"שם פרטי"}
                      name={"firstName"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      type={"text"}
                      values={values.firstName}
                      errors={errors.firstName}
                      touched={touched.lastName}
                    />
                    <Inputs
                      title={"שם משפחה"}
                      name={"lastName"}
                      type={"text"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.lastName}
                      errors={errors.lastName}
                      touched={touched.lastName}
                    />
                  </div>
                  <div className={isMobile ? "" : "flex"}>
                    <Inputs
                      title={"טלפון נייד"}
                      name={"mobileNumber"}
                      type={"text"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.mobileNumber.replace(/[^0-9]/g, "")}
                      errors={errors.mobileNumber}
                      touched={touched.mobileNumber}
                    />
                    <Inputs
                      title={"מייל"}
                      name={"email"}
                      type={"email"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.email}
                      errors={errors.email}
                      touched={touched.email}
                    />
                  </div>
                  <div className={isMobile ? "" : "flex"}>
                    <Inputs
                      title={"שם בית ספר"}
                      type={"text"}
                      name={"schoolName"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.schoolName}
                      errors={errors.schoolName}
                      touched={touched.schoolName}
                    />
                    <Inputs
                      title={"סמל מוסד"}
                      type={"text"}
                      name={"symbol"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.symbol}
                      errors={errors.symbol}
                      touched={touched.symbol}
                    />
                  </div>
                  <div className={isMobile ? "" : "flex"}>
                    <Inputs
                      title={"ישוב"}
                      name={"city"}
                      type={"text"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.city}
                      errors={errors.city}
                      touched={touched.city}
                    />

                    <Inputs
                      title={"תפקיד"}
                      name={"role"}
                      type={"text"}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      values={values.role}
                      errors={errors.role}
                      touched={touched.role}
                    />
                  </div>
                  <div className="choose-section-title">
                    <div className="choose-blue">
                      בחרו את התוכניות שמעניינות אתכם, ואנו נדאג לחזור אליכם.{" "}
                    </div>
                    <div className="choose-regular">
                      {" "}
                      אפשר וכדאי לבחור יותר מתוכנית אחת.
                    </div>
                    <div
                      className={
                        isMobile
                          ? "course-homepage-error course-homepage-error-mobile"
                          : "course-homepage-error"
                      }
                    >
                      {errors.courses && touched.courses && errors.courses}
                    </div>
                  </div>
                  <div role="group" aria-labelledby="checkbox-group">
                    <div className="course-flex">
                      {courseType?.[`type${typeId}`]
                        ? courseType?.[`type${typeId}`].map((n, i) => (
                            <CheckBoxCourse
                              value={n.value}
                              key={`course-box-${i}`}
                            />
                          ))
                        : "לא קיימת רשימה"}
                    </div>
                    <CheckBox />
                  </div>
                  <button
                    type="submit"
                    className={
                      isMobile ? "submit-style-mobile" : "submit-button-style"
                    }
                  >
                    {activeLoader ? <Loader /> : "חזרו אליי"}
                  </button>{" "}
                  <FormikError />
                </form>
              )}
            </Formik>
            <div className={isMobile ? "law-text-mobile" : "law-text"}>
              <div>
                המרכז לטכנולוגיה חינוכית שומר על פרטיות המידע שנמסר על ידך על פי
                חוק. המידע נשמר בחוות השרתים של מטח ואין אליו גישה לגופים אחרים.
                הפרטים הנמסרים על ידך עשויים
              </div>
              <div>
                לשמש לצורך משלוח דבר פרסומת על ידי מטח ומי מטעמה. ביכולתך להסיר
                את פרטיך מהרשימה בכל עת ובקלות רבה.
              </div>
            </div>
          </div>
        );
      case "bad":
        return <FallPage />;
      case "ok":
        return <SuccessPage />;
      default:
        return "foo";
    }
  };

  return (
    <>
      <div className="center">{renderSwitch(page)}</div>
    </>
  );
}
